// HTML tabeli dla wariantu "table" w ImageSection.
// Klasy: "yes" = zielony ✓, "na" = pomarańczowy ✗.
export const comparisonTableHtml = `
<table>
    <thead>
        <tr><th>Functional Layer</th><th>CaaS Alone</th><th>CaaS + Wyden</th></tr>
    </thead>
    <tbody>
        <tr><td>Street-side execution and custody</td><td class="yes">✓</td><td class="yes">✓</td></tr>
        <tr><td>Regulatory licensing (MiCA, VARA, etc.)</td><td class="yes">✓</td><td class="yes">✓</td></tr>
        <tr><td>Client-side order management</td><td class="na">✗</td><td class="yes">✓</td></tr>
        <tr><td>Client pricing, quoting &amp; fee management</td><td class="na">✗</td><td class="yes">✓</td></tr>
        <tr><td>Agency &amp; principal trading risk model support</td><td class="na">✗</td><td class="yes">✓</td></tr>
        <tr><td>Multi-LP best execution &amp; Smart Order Routing</td><td class="na">✗</td><td class="yes">✓</td></tr>
        <tr><td>Operational resilience (e.g. DORA in the EU)</td><td class="na">✗</td><td class="yes">✓ automated failover across LPs &amp; custodians</td></tr>
        <tr><td>Post-trade settlement (multi-LP / multi-custody)</td><td class="na">✗</td><td class="yes">✓</td></tr>
        <tr><td>Custody diversification support</td><td class="na">✗</td><td class="yes">✓ manages multiple custodians centrally</td></tr>
        <tr><td>Omnibus-to-client sub-ledger post-trade allocation</td><td class="na">✗</td><td class="yes">✓</td></tr>
        <tr><td>Real-time client position &amp; P&amp;L management</td><td class="na">✗</td><td class="yes">✓</td></tr>
        <tr><td>Double-entry, banking-grade bookkeeping</td><td class="na">✗</td><td class="yes">✓</td></tr>
        <tr><td>Scalable to new products &amp; services</td><td class="na">✗</td><td class="yes">✓ plug in new LP &amp; custody venues, use cases &amp; models</td></tr>
    </tbody>
</table>
`;
